import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_APP_NAME: z.string().min(1).default('MaeFwk10'),
  VITE_DEFAULT_LANG: z.string().default('it-IT'),
  /** Client id Google Identity Services: se assente il bottone "Accedi con Google" non compare. */
  VITE_GOOGLE_CLIENT_ID: z.string().optional(),
});

const parsed = envSchema.safeParse(import.meta.env);
if (!parsed.success) {
  console.error('Invalid env config', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid env configuration');
}

export const env = parsed.data;
